export const API_KEY = "f9e6afddb568c3eac19893218b578cea";
export const PATH = "https://api.themoviedb.org/3/";
export const POPULAR = "discover/movie?sort_by=popularity.desc";
export const KIDS =
  "discover/movie?certification_country=US&certification.lte=G&sort_by=popularity.desc";
export const DRAMA = "discover/movie?with_genres=18&primary_release_year=2014";
export const THEATHER =
  "discover/movie?primary_release_date.gte=2014-09-15&primary_release_date.lte=2014-10-22";
export const AUTENTICATION = "&api_key=";
